import { useGetTimelyActionMeasures } from './useGetTimelyActionMeasures';

export const useReminderService = () => {
    const getTimelyActionMeasures = useGetTimelyActionMeasures();

    return {
        getTimelyActionMeasures,
    };
};
